<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        MANAGE STATUS
                    </h1>
                </v-col>
                <v-col :cols="6" class="text-right"> </v-col>
            </v-row>
        </v-container>
        <v-card>
            <v-card-title>
                <!-- <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                ></v-text-field> -->
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    dark
                    small
                    rounded
                    class="mb-2"
                    @click="add_status()"
                    ><v-icon small class="mr-1">mdi-plus</v-icon>Add
                    Status</v-btn
                >
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="data_status"
                :search="search"
                :loading="isLoading"
                loading-text="Loading... Please wait"
            >
                <template v-slot:[`item.btn`]="{ item }">
                    <v-icon small class="mr-2" @click="edit(item)">
                        mdi-square-edit-outline
                    </v-icon>
                    <!-- <v-icon small @click="del(item.permission_type_id)">
                        mdi-delete
                    </v-icon> -->
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field
                                    label="Status Name"
                                    v-model="status.permission_type_name"
                                    :rules="nameR"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="save(status.permission_type_id)"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div id="snackbar">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
export default {
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.chk_url()
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        async chk_url() {
            let send = {
                url: this.$route.path,
            }
            await axios
                .post(
                    `${process.env.VUE_APP_ROOT_API}/api/` + "check-auth",
                    send,
                    this.tk
                )
                .then((response) => {
                    if (response.data.status == "error") {
                        this.$root.$router.push({
                            path: "/404",
                        })
                    } else {
                        this.get_user()
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_user() {
            let url = `${process.env.VUE_APP_ROOT_API}/api/permissiontype/`
            let { data } = await axios.get(url)
            this.data_status = data
        },
        add_status() {
            this.formTitle = "New Status"
            this.status = { ...this.st }
            this.dialog = true
        },
        close() {
            this.get_user()
            this.dialog = false
        },
        async save(id) {
            this.mutatesnackbar()
            let data_new_status = { ...this.status }
            let url = `${process.env.VUE_APP_ROOT_API}/api/permissiontype/`
            if (this.formTitle == "New Status") {
                await axios.post(url, data_new_status)
            } else if (this.formTitle == "Edit Status") {
                try {
                    await axios.put(url + id, data_new_status)
                } catch (error) {
                    console.log(error)
                }
            }
            this.close()
            if (this.snackbar === true) {
                setTimeout(() => {
                    this.mutatesnackbar()
                    this.snackbar
                }, 2000)
            }
        },
        edit(data) {
            this.formTitle = "Edit Status"
            let data_edit = (this.status = data)
            this.dialog = true
        },
        async del(id) {
            let url = `${process.env.VUE_APP_ROOT_API}/api/permissiontype/` + id
            if (confirm("Are you sure you want to delete this project?")) {
                try {
                    await axios.delete(url)
                    this.get_user()
                } catch (error) {
                    console.log(error)
                }
            }
        },
    },
    data() {
        return {
            tk: null,
            headers: [
                {
                    text: "Name",
                    value: "permission_type_name",
                },
                {
                    text: "Action",
                    align: "center",
                    value: "btn",
                },
            ],
            data_status: [],
            search: "",
            dialog: false,
            formTitle: "",
            st: {
                name: "",
            },
            status: {
                name: "",
            },
            text: "Success, Your work has been saved",
            nameR: [(v) => !!v || "Status Name is required"],
        }
    },
}
</script>
